// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"p2-z","dimensionLabel":"q2-z","styleChooserControlWrapper":"r2-z","styleChooserControl":"s2-z","disabled":"t2-z","giftCard":"u2-z","styleChooserText":"v2-z"};